import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const Disqualified = ({ isLinkCodeFlow, values }) => (
  <Content>
    {({
      initialQuestionsDisqualifiedLabel,
      initialQuestionsDisqualifiedYes = '',
      initialQuestionsDisqualifiedNo = '',
      bannedText = '',
      initialQuestionsDisqualifiedLinkLabel
    }) => (
      <Field name="disqualified" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="disqualified"
            hasError={touched && !!error}
            title={
              isLinkCodeFlow
                ? initialQuestionsDisqualifiedLinkLabel
                : initialQuestionsDisqualifiedLabel
            }
            description={bannedText}
          >
            <GenericRadio.InlineSet
              groupName="disqualified-group"
              items={[
                {
                  id: initialQuestionsDisqualifiedYes,
                  labelText: initialQuestionsDisqualifiedYes
                },
                {
                  id: initialQuestionsDisqualifiedNo,
                  labelText: initialQuestionsDisqualifiedNo
                }
              ]}
              {...input}
              selectedId={values.disqualified}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default Disqualified;
